import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MlModel, MlModelCreate, MlModelFilter } from '../data/mlModel';

export function createMlModelService(client: AxiosInstance) {
  return createCrudService<MlModel, MlModelCreate, MlModelFilter>(
    client,
    '/ai/MlModel',
    'id',
  );
}

export type MlModelService = CrudService<MlModel, MlModelCreate, MlModelFilter>;
